import { INode } from '@cbridge-packages/node';
import { INavigationBlockItemBase } from '@cbridge-tools/navigation-block';
import { generateNodeStreamsRoute } from '@cbridge-packages/routing-client-admin';

export const nodeAsStreamsNavigationItem = (node: INode): INavigationBlockItemBase => ({
  value: node.nodeId,
  label: node.name,
  href: generateNodeStreamsRoute(node.nodeId),
});
